import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useI18n, languages } from '@/i18n';

interface HreflangTagsProps {
  currentPath: string; // Path without language prefix
  baseUrl?: string;
}

export const HreflangTags: React.FC<HreflangTagsProps> = ({ 
  currentPath, 
  baseUrl = 'https://www.aureum7trading.com' 
}) => {
  const { language } = useI18n();
  
  // Clean the path
  const cleanPath = currentPath.startsWith('/') ? currentPath : `/${currentPath}`;
  const pathSuffix = cleanPath === '/' ? '' : cleanPath;
  
  return (
    <Helmet>
      {/* Generate hreflang for each language */}
      {languages.map((lang) => (
        <link
          key={lang.code}
          rel="alternate"
          hrefLang={lang.locale}
          href={`${baseUrl}/${lang.code}${pathSuffix}`}
        />
      ))}
      
      {/* x-default for search engines (points to English) */}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`${baseUrl}/en${pathSuffix}`}
      />
      
      {/* Canonical for current language */}
      <link
        rel="canonical"
        href={`${baseUrl}/${language}${pathSuffix}`}
      />
    </Helmet>
  );
};

export default HreflangTags;
